import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

export const useMoveToSetting = () => {
  const navigation = useRootStackNavigation();

  return useCallback(() => {
    navigation.push('Setting', {});
  }, [navigation]);
};
